<template>
  <div class="vld-parent">
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :on-cancel="onCancel"
      :is-full-page="fullPage"
    ></loading>

    <h1>Verkaufte Artikel</h1>
    <div class="card">
      <div class="card-body">
        <BaseFilteringComponent></BaseFilteringComponent>

        <div class="form-group row">
          <div class="col-sm-1 col-form-label">Suche</div>
          <div class="col-md-2">
            <input
              type="text"
              v-model="filterSQ"
              class="form-control form-control-sm"
              placeholder="SKU"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <table class="table table-bordered table-striped table-small">
              <tr>
                <td>
                  <strong>Anzahl verkaufter Artikel</strong>
                </td>
                <td>{{num_articles}}</td>
                <td>
                  <strong>Summe Netto</strong>
                </td>
                <td>{{sum_netto}} €</td>
                <td>
                  <strong>Marge</strong>
                </td>
                <td>{{totalRTMargin}} €</td>
                <td>
                  <strong>Summe EK</strong>
                </td>
                <td>{{sum_ek}} €</td>
              </tr>
            </table>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div class="float-right">
              <button v-on:click="refreshData" class="btn btn-primary btn-sm">
                <font-awesome-icon icon="sync" />Refresh
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <a
      @click="downloadCSV"
      class="btn btn-primary btn-sm"
      style="margin-top: 10px; margin-bottom: 10px"
    >
      <font-awesome-icon icon="download" />CSV Download
    </a>

    <table class="table table-striped table-bordered table-hover table-small">
      <thead>
        <tr>
          <th>EAN</th>
          <th>SKU</th>
          <th>Bezeichnung</th>
          <th>Menge</th>
          <th>Preis Brutto</th>
          <th>Preis Netto</th>
          <th>Summe Brutto</th>
          <th>Summe Netto</th>
          <th>EK Einzel</th>
          <th>EK Summe</th>
          <th>Marge %</th>
          <th>Marge Einzel</th>
          <th>Marge Summe</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="article in articles" v-bind:key="article.sku">
          <td>{{article.ean}}</td>
          <td>{{article.sku}}</td>
          <td>{{article.name}}</td>
          <td>{{article.quantity}}</td>
          <td>{{article.price}}</td>
          <td>{{article.price_netto}}</td>
          <td>{{article.sum_price_brutto}}</td>
          <td>{{article.sum_price_netto}}</td>
          <td>{{article.ek_price_single}}</td>
          <td>{{article.ek_price_sum}}</td>
          <td>{{article.margin_percentage}}</td>
          <td>{{article.rt_margin_single}}</td>
          <td>{{article.rt_margin}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
const request = require("superagent");
import axios from "axios";
import Loading from "vue-loading-overlay";
import BaseFilteringComponent from "@/components/BaseFilteringComponent";
import "vue-loading-overlay/dist/vue-loading.css";
import FileSaver from "file-saver";

export default {
  name: "ArticlesBoughtListing",
  data() {
    // default is the current month
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    firstDay = require("moment")(firstDay).format("YYYY-MM-DD");
    lastDay = require("moment")(lastDay).format("YYYY-MM-DD");

    return {
      articles: [],
      api_token: null,
      from_date: firstDay,
      to_date: lastDay,
      num_articles: 0,
      sum_netto: 0,
      sum_margin: 0,
      sum_ek: 0,
      isLoading: false,
      fullPage: true,
      shopFilter: null,
      totalRTMargin: 0,
      filterSQ: "",
    };
  },
  props: ["api_key"],
  components: {
    Loading,
    BaseFilteringComponent: BaseFilteringComponent,
  },
  mounted: function () {},
  computed: {
    shopListing: function () {
      return this.$store.state.shops;
    },
    filterShopId() {
      return this.$store.state.filter_shop_id;
    },
    filterFromDate() {
      return this.$store.state.filter_from_date;
    },
    filterToDate() {
      return this.$store.state.filter_to_date;
    },
    currentUser: function () {
      return this.$store.state.current_user;
    },
    downloadUrl: function () {
      var url = this.baseUrl + "&format=csv";
      return url;
    },
    baseUrl() {
      var url =
        process.env.API_HOST +
        "/api/articles/bought?filter_from_date=" +
        this.filterFromDate +
        "&filter_to_date=" +
        this.filterToDate +
        "&filter_sq=" +
        this.filterSQ;
      if (
        this.currentUser.master == 1 &&
        this.filterShopId != null &&
        parseInt(this.filterShopId) != 0
      ) {
        url = url + "&filter_shop_ids=" + this.filterShopId;
      }
      return url;
    },
  },
  methods: {
    downloadCSV() {
      this.api_token = localStorage.getItem("API_TOKEN");
      var that = this;
      request
        .get(this.downloadUrl)
        .set("Authorization", this.api_token)
        .then(function (res) {
          var blob = new Blob(["\uFEFF" + res.text], {
            type: "text/comma-separated-values;charset=utf-8",
          });

          FileSaver.saveAs(blob, "verkaufte_artikel.csv", { autoBom: true });
        });
    },
    onCancel: function () {},
    fetch: function () {
      this.api_token = localStorage.getItem("API_TOKEN");

      var url = this.baseUrl;

      this.isLoading = true;
      var that = this;
      request
        .get(url)
        .set("Accept", "application/json")
        .set("Authorization", this.api_token)
        .then(function (res) {
          that.from_date = res.body.from_date;
          that.to_date = res.body.end_date;
          that.articles = res.body.articles;
          that.num_articles = res.body.total_sold_articles;
          that.sum_netto = res.body.total_netto;
          that.sum_ek = res.body.total_ek;
          that.sum_margin = res.body.sum_margin;
          that.isLoading = false;
          that.totalRTMargin = res.body.total_rt_margin;
        });
    },
    refreshData: function () {
      this.fetch();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ArticlesBoughtListing.vue